// extracted by mini-css-extract-plugin
export default {"input":"Aaa-z","button":"Baa-z","selected":"Caa-z","unavailable":"Daa-z","oos":"Eaa-z","paperCutDisabledOverlay":"Faa-z","image":"Gaa-z"};